import { render, staticRenderFns } from "./CuadraturaSerie.vue?vue&type=template&id=b80ec0e8&"
import script from "./CuadraturaSerie.vue?vue&type=script&lang=js&"
export * from "./CuadraturaSerie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports